import { InitialLocationCallback, MapInitialLocationProvider } from '../map-container/map-initial-location.provider';
import { MapComponent } from '../map.component';

export abstract class MapFlow implements MapInitialLocationProvider {
  constructor(protected mapComponent: MapComponent) {}

  public abstract activate(): void;

  public abstract deactivate(): void;

  public abstract markersWereUpdated(): void;

  public abstract getInitialLocation(successCallback: InitialLocationCallback): void;
}
